	Object.defineProperty(exports, "__esModule", {
	    value: true
	});exports.default=window.GrimoireJS.lib.math.Matrix;


//////////////////
// WEBPACK FOOTER
// ./~/grimoirejs-math/ref/Matrix.js
// module id = 4
// module chunks = 0